import React from 'react';
import { markerSizes, backendToDisplay } from './MarkerStyles';
import { linkifyHtml } from '../../utils/textUtils';

const MarkerPopupContent = ({ marker, onDelete, onSizeChange }) => {
  const handleDelete = () => {
    if (window.confirm('Bu işaretleyiciyi silmek istediğinizden emin misiniz?')) {
      onDelete(marker._id || marker.id);
    }
  };

  const handleSizeChange = (newSize) => {
    if (onSizeChange) {
      onSizeChange(marker._id || marker.id, newSize);
    }
  };

  return (
    <div className="p-3 min-w-[250px]">
      {/* Event Title */}
      <h3 className="font-semibold text-lg mb-2 text-gray-800">
        {marker.title || marker.storyEvent_id?.title || 'Başlıksız Olay'}
      </h3>

      {/* Event Description */}
      {(marker.description || marker.storyEvent_id?.description) && (
        <div
          className="text-sm text-gray-600 mb-3 line-clamp-3"
          dangerouslySetInnerHTML={{
            __html: linkifyHtml(marker.description || marker.storyEvent_id?.description)
          }}
        />
      )}

      {/* Category Badge */}
      {marker.storyEvent_id?.category_id && (
        <div className="mb-3">
          <span
            className="inline-block px-2 py-1 rounded-full text-xs font-medium text-white"
            style={{ backgroundColor: marker.storyEvent_id.category_id.color }}
          >
            {marker.storyEvent_id.category_id.name}
          </span>
        </div>
      )}

      {/* Marker Controls */}
      <div className="border-t pt-3 mt-3">
        {/* Size Control */}
        {onSizeChange && (
          <div className="mb-3">
            <label className="block text-xs font-medium text-gray-700 mb-1">
              İşaretleyici Boyutu
            </label>
            <select
              value={marker.size || 'm'}
              onChange={(e) => handleSizeChange(e.target.value)}
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              {Object.entries(markerSizes).map(([size, pixels]) => (
                <option key={size} value={size}>
                  {backendToDisplay(size)} ({pixels}px)
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Delete Button */}
        {onDelete && (
          <button
            onClick={handleDelete}
            className="w-full px-3 py-1 bg-red-500 hover:bg-red-600 text-white text-xs font-medium rounded transition-colors"
          >
            İşaretleyiciyi Sil
          </button>
        )}
      </div>
    </div>
  );
};

export default MarkerPopupContent; 